import Layout from '../Layout/Layout';
import { Button, Row, Col, Container } from 'reactstrap';
import { useTranslator, useAppContext } from '@front-activerse/common-components';

const ErrorNetwork = ({ resetErrorBoundary }) => {
  const { t } = useTranslator();

  const {
    images: { networkErrorImg },
  } = useAppContext();

  const handleRefresh = () => {
    resetErrorBoundary();
  };
  return (
    <Layout>
      <div className="page-template-error">
        <section className="text-center d-flex align-items-center full-height">
          <Container>
            <Row>
              <Col md={{ size: 4, offset: 4 }}>
                <img
                  src={networkErrorImg}
                  className="img-fluid mb-xl"
                  width="343"
                  height="250"
                  alt=""
                />
                <h2 className="title-medium semi-bold mb-xl">{t('networkError.title')}</h2>
                <Button color="primary" className="w-100" onClick={handleRefresh}>
                  {t('networkError.refresh.button')}
                </Button>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
    </Layout>
  );
};

export default ErrorNetwork;
